
import { Options, Vue } from "vue-class-component";
import PaginationV3 from "@/app/ui/components/pagination-v3/index.vue";
import formatDate from '@/app/infrastructures/misc/common-library/FormatDate';
import { BulkBookingController } from "@/app/ui/controllers/BulkBookingController";
import { OptionsClass } from "@/domain/entities/MainApp";
import DownloadTemplate from "../download-template.vue";
import UploadFile from "../upload-file.vue"
import { MainAppController } from "@/app/ui/controllers/MainAppController";

@Options({
  components: {
    PaginationV3,
    DownloadTemplate,
    UploadFile
  }
})
export default class TabsCSV extends Vue {

  mounted() {
    this.onRefreshBulkList();
  }

  getBulkList() {
    BulkBookingController.fetchBulkBookingList({
      search: this.searchValue,
      createdId: 0,
      createdType: "",
      status: this.uploadStatus.value || "",
      archiveType: "district-operational"
    });
  }

  onRefreshBulkList() {
    this.searchValue = "";
    this.uploadStatus = new OptionsClass({ name: "", value: "" });
    this.bulkListPagination.page = 1;
    this.getBulkList();
  }

  get bulkListData() {
    return BulkBookingController.bulkBookingList.data;
  }

  get bulkListPagination() {
    return BulkBookingController.bulkBookingList.pagination;
  }

  get loading() {
    return BulkBookingController.isLoading;
  }

  get errorCause() {
    return BulkBookingController.errorCause;
  }

  isEnableDownload(status: string) {
    return status.toLowerCase() === "failed" || status.toLowerCase() === "partially";
  }

  mapStatus(status: string) {
    const label: any = {
      success: "Berhasil",
      partially: "Berhasil sebagian",
      failed: "Gagal",
      uploading: "Verifikasi Data"
    };

    const style: any = {
      success: "bg-green-lp-300 text-green-lp-200",
      partially: "bg-yellow-lp-200 text-yellow-lp-100",
      failed: "bg-red-300 text-red-lp-100",
      uploading: "bg-gray-lp-200 text-black-lp-300"
    };

    return {
      label: label[status.toLowerCase()] ?? "-",
      style: style[status.toLowerCase()] ?? ""
    };
  }

  onDownloadData(item: any) {
    BulkBookingController.downloadFailedFileUrsa(item)
  }

  toPageV3(value: number) {
    if (value === this.bulkListPagination.page) {
      return;
    }
    this.bulkListPagination.page = value;
    this.getBulkList();
  }

  // Format Date
  formatDateToString(date: string) {
    return formatDate(date);
  }

  // search filter
  searchValue = "";

  onSearch(value: any) {
    this.searchValue = value;
    this.bulkListPagination.page = 1;
    this.getBulkList();
  }

  clearSearch() {
    this.searchValue = "";
    this.bulkListPagination.page = 1;
    this.getBulkList();
  }

  // status filter
  get statusData(): OptionsClass[] {
    return [
       new OptionsClass({ name: "Verifikasi", value: "uploading" }),
       new OptionsClass({ name: "Berhasil", value: "success" }),
       new OptionsClass({ name: "Berhasil sebagian", value: "partially" }),
       new OptionsClass({ name: "Gagal", value: "failed" })
    ]
  }

  uploadStatus = new OptionsClass({ name: "", value: "" });

  onChangeStatus(item: OptionsClass) {
    if (this.uploadStatus.value === item.value) {
      this.uploadStatus = new OptionsClass({ name: "", value: "" });
    } else {
      this.uploadStatus = new OptionsClass({ name: item.name, value: item.value });
    }
    this.bulkListPagination.page = 1;
    this.getBulkList();
  }


  get offset(): number {
    return (
      this.bulkListPagination.limit * (this.bulkListPagination.page - 1)
    );
  }

  get noDataHasFilter() {
    return !this.bulkListData.length && (this.searchValue || this.uploadStatus.value);
  }

  get isSidebarAndBreadcrumbV2() {
    return MainAppController.isSidebarAndBreadcrumbV2;
  }

  totalFileGeojson(item: any) {
    return item.status.toLowerCase() === 'uploading' ? '-' : `${item.dataProcessedCurrent}/${item.totalDataCurrent}`
  }
}
